var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.414,
    height: 7.414,
    viewBox: "0 0 7.414 7.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Claose_Button",
    "data-name": "Claose Button",
    transform: "translate(0.707 0.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M2,2,8,8M8,2,2,8",
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#ffa539",
    strokeLinecap: "round",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcon);
export default __webpack_public_path__ + "static/media/Clear Icon.d32aaec1d910afedf3b1523840c190c8.svg";
export { ForwardRef as ReactComponent };